// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"97":"0cf2b9d773d1c6b2","158":"3760456134dd6a81"}[chunkId] + ".js";
};